











import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  BaiduMap,
  BmMarker,
  BmInfoWindow
} from 'vue-baidu-map';

@Component({
  components: {
    BaiduMap,
    BmMarker,
    BmInfoWindow
  }
})
export default class InsBaiduMap extends Vue {
  @Prop({ default: '100%' }) private width!: string; // 地图宽度
  @Prop({ default: '500px' }) private height!: string; // 地图高度
  @Prop({ default: 116.404 }) private lng!: number; // 经度
  @Prop({ default: 39.915 }) private lat!: number; // 纬度
  @Prop({ default: '' }) private markText!: string; // 标注文本

  show: boolean = true;

  infoWindowClose () {
    this.show = false;
  };

  infoWindowOpen () {
    this.show = true;
  };
};
